<template>
  <v-container class="px-7" fluid>
    <v-row no-gutters align="center" justify="space-between" class="mb-3 mt-2">
      <v-col cols="12" sm="6">
        <h1 class="fs-20 font-weight-bold bluedarken--text">
          Pending {{ item.name }}
        </h1>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn color="primary" icon large>
          <v-icon
            class="icon-large icon-bold"
            color="bluedarken"
            @click="refresh"
          >
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-card :loading="loading" class="elevation-card rounded-12 mb-5">
      <v-card-title>
        <v-icon color="primary2" class="mr-2">
          mdi-web
        </v-icon>
        <span class="fs-14 font-weight-bold primary2--text">
          Request
        </span>
        <v-spacer />
        <select-column-filter
          v-model="columnActive"
          :headers="headers"
          customClass="ma-0"
        />
        <v-btn
          depressed
          dark
          color="menuActive"
          class="btn-medium ml-3"
          @click="download"
          :loading="downloading"
        >
          Download
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-simple-table
          fixed-header
          class="table-taxonomy nav-table sshcf-table"
        >
          <template v-slot:default>
            <VuePerfectScrollbar
              class="drawer-menu--scroll"
              :settings="scrollSettings"
            >
              <thead>
                <tr>
                  <template v-for="(header, index) in headers">
                    <th
                      v-if="isHeaderSelected(header)"
                      :key="header.text"
                      class="white--text"
                      :class="{
                        [`text-${header.align}`]: true,
                        [header.customClass]: !!header.customClass
                      }"
                    >
                      <span>{{ header.text }}</span>
                      <filter-column
                        v-if="header.value !== 'action'"
                        :indexItem="index"
                        :field="header.value"
                        :listFilter="getFiltered(header.value, index)"
                        :columnType="header.columnType || false"
                        :isCode="header.isCode"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        @filterItem="searchCln"
                      />
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="request in filteredItems"
                  :key="request.name"
                  class="hoverable-tr"
                >
                  <td
                    v-if="isColumnSelected('unique_code')"
                    @click="onRowClicked(request)"
                    class="sticky-body1"
                  >
                    <router-link
                      :to="`/sshcp/request/${request.id}`"
                      class="bluedarken--text text-link"
                    >
                      {{ request.unique_code }}
                    </router-link>
                  </td>
                  <td
                    v-if="isColumnSelected('po_number')"
                    @click="onRowClicked(request)"
                  >
                    {{ request.po_number }}
                  </td>
                  <td
                    v-if="isColumnSelected('io_number')"
                    @click="onRowClicked(request)"
                  >
                    {{ request.io_number }}
                  </td>
                  <td
                    v-if="isColumnSelected('house')"
                    @click="onRowClicked(request)"
                  >
                    {{ request.house }}
                  </td>
                  <td
                    v-if="isColumnSelected('region')"
                    @click="onRowClicked(request)"
                  >
                    {{ request.region }}
                  </td>
                  <td
                    v-if="isColumnSelected('district')"
                    @click="onRowClicked(request)"
                  >
                    {{ request.district }}
                  </td>
                  <td
                    v-if="isColumnSelected('type_of_activity')"
                    @click="onRowClicked(request)"
                  >
                    {{ request.type_of_activity }}
                  </td>
                  <td
                    v-if="isColumnSelected('events')"
                    @click="onRowClicked(request)"
                  >
                    {{ request.events }}
                  </td>
                  <td
                    v-if="isColumnSelected('total_budget')"
                    @click="onRowClicked(request)"
                    class="text-right"
                  >
                    {{ idr(request.total_budget) }}
                  </td>
                  <td
                    v-if="isColumnSelected('cost_per_pax')"
                    @click="onRowClicked(request)"
                    class="text-right"
                  >
                    {{ idr(request.cost_per_pax) }}
                  </td>
                  <td
                    v-if="isColumnSelected('local_status')"
                    @click="onRowClicked(request)"
                    class="text-uppercase"
                  >
                    {{ request.local_status }}
                  </td>
                  <td v-if="isColumnSelected('action')">
                    <v-btn
                      text
                      color="primary"
                      class="text-capitalize font-weight-bold"
                      :to="`/sshcp/request/detail/${request.id}`"
                    >
                      <v-img
                        src="@/assets/images/icon-doc.png"
                        width="16"
                        height="16"
                        class="mr-2"
                      />
                      Details
                    </v-btn>
                    <preval-number
                      v-if="item.name === 'Approval After B-Right'"
                      :item="request"
                      @fetchData="fetch"
                    />
                  </td>
                </tr>
                <tr v-if="!filteredItems.length">
                  <td :colspan="headers.length" class="text-center">
                    {{ loading ? 'Loading...' : 'No data available' }}
                  </td>
                </tr>
              </tbody>
            </VuePerfectScrollbar>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="900px">
      <card-progress-tracking
        v-if="progressTracking"
        :loading="loadingDetail"
        :steps="steps"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import FilterColumn from '@/components/filterColumn';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapState } from 'vuex';
import { formatDate } from '@/utils/helpers';
import { toCurrencyWithoutSign } from '@/mixins/filter';
import SelectColumnFilter from '@/components/SelectColumnFilter';
import CardProgressTracking from '@/components/SSHCP/CardProgressTracking';
import { exportToExcel } from '@/utils/helpers';
import moment from 'moment';
import PrevalNumber from '@/components/SSHCP/PrevalNumber';

export default {
  props: {
    item: {}
  },
  components: {
    VuePerfectScrollbar,
    CardProgressTracking,
    SelectColumnFilter,
    FilterColumn,
    PrevalNumber
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 340
    },
    items: [],
    columnActive: [],
    loading: false,
    dialog: false,
    loadingDetail: false,
    downloading: false
  }),
  computed: {
    ...mapState('sshcp', {
      progressTracking: 'progressTracking'
    }),
    headers() {
      return [
        {
          text: 'SSHCP Code',
          align: 'left',
          value: 'unique_code',
          customClass: 'sticky-header1'
        },
        {
          text: 'PO Number',
          align: 'left',
          value: 'po_number',
          isCode: true
        },
        {
          text: 'IO Number',
          align: 'left',
          value: 'io_number',
          isCode: true
        },
        {
          text: 'House',
          align: 'left',
          value: 'house'
        },
        {
          text: 'Region',
          align: 'left',
          value: 'region'
        },
        {
          text: 'District',
          align: 'left',
          value: 'district'
        },
        {
          text: 'Type of Activity',
          align: 'left',
          value: 'type_of_activity'
        },
        {
          text: 'Event',
          align: 'left',
          value: 'events'
        },
        {
          text: 'Total Budget',
          align: 'left',
          value: 'total_budget',
          formatter: toCurrencyWithoutSign,
          columnType: true,
          exportFormat: val => +val
        },
        {
          text: 'Cost Per Pax',
          align: 'center',
          value: 'cost_per_pax',
          formatter: toCurrencyWithoutSign,
          columnType: true,
          exportFormat: val => +val
        },
        {
          text: 'Status',
          align: 'left',
          value: 'local_status'
        },
        {
          text: 'Action',
          align: 'center',
          value: 'action'
        }
      ];
    },
    steps() {
      return this.progressTracking.map(item => {
        let itemApproved = item.find(val => val.approval_date !== null);
        return {
          group_name: item[0].group_name,
          email: item.map(val => val.email.toLowerCase()),
          name: item.map(val => {
            return {
              name: val.user_name,
              isApproved: !!val.approval_date
            };
          }),
          complete: itemApproved?.status === 'approved',
          date: itemApproved ? formatDate(itemApproved.approval_date) : '',
          status: itemApproved?.status,
          notes: itemApproved?.notes
        };
      });
    },
    filteredItems() {
      return this.getFilteredItems();
    },
    isSelectedAll: {
      get() {
        return this.headers
          ? this.columnActive.length === this.headers.length
          : false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.headers.forEach(function(user) {
            selected.push(user);
          });
        }

        this.columnActive = selected;
      }
    }
  },
  watch: {
    item: {
      immediate: true,
      async handler() {
        await this.fetch();
        this.selectAllColumn();
      }
    }
  },
  created() {
    this.selectAllColumn();
  },
  methods: {
    async refresh() {
      await this.fetch();
      this.selectAllColumn();
    },
    selectAllColumn() {
      this.columnActive = this.headers;
    },
    async fetch(params = {}) {
      this.loading = true;
      let endpoint = '';
      if (this.item.name === 'Approval Before B-Right') {
        endpoint = 'sshcp/getApprovalBeforeBright';
      } else {
        endpoint = 'sshcp/getApprovalAfterBright';
      }
      const res = await this.$store.dispatch(endpoint, {
        ...params,
        sort: 'desc',
        paginate: false,
        orderBy: 'updated_at'
      });
      this.loading = false;
      this.items = res.data.result.map(item => ({
        ...item,
        created_date: formatDate(item.created_date),
        events:
          item.events.length > 0
            ? item.events.map(val => val.name).join(', ')
            : '',
        local_status: item.local_status?.split('_').join(' ')
      }));
    },
    onRowClicked(item) {
      this.getDetail(item.id);
    },
    async getDetail(id) {
      this.dialog = true;
      this.loadingDetail = true;
      await this.$store.dispatch('sshcp/getProgressTracking', id);
      this.loadingDetail = false;
    },
    toggleSelectAll() {
      this.isSelectAll = !this.isSelectAll;
    },
    isHeaderSelected(header) {
      return this.columnActive.map(item => item.value).includes(header.value);
    },
    isHeaderSelectedByValue(value) {
      return this.columnActive.map(item => item.value).includes(value);
    },
    isColumnSelected(name) {
      return this.columnActive.filter(item => item.value === name).length > 0;
    },
    getAscSort(obj) {
      this.items.sort(this.dynamicSort(obj.fieldName));
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.items);
    },
    searchCln(obj) {
      this.filter = obj;
    },
    getFilteredItems() {
      const obj = this.filter;
      let arr = this.items;

      if (!obj) return arr;

      let nameField = obj.fieldName;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      let result = [];
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        result = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(String(a[nameField]));
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 4) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else {
          result = this.items;
        }
      }

      return result;
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        return Object.keys(
          this.items.reduce((result, arr) => {
            result[arr[name]] = [...(result[arr[name]] || []), arr];
            return result;
          }, {})
        );
      } else {
        let nameField = name.split('.');
        return Object.keys(
          this.items.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {})
        );
      }
    },
    async download() {
      this.downloading = true;
      const headers = this.headers.filter(item => item.value !== 'action');
      const columns = headers.map(item => item.text);
      const items = this.filteredItems.map(item =>
        headers.map(header =>
          header.formatter
            ? header.formatter(item[header.value])
            : item[header.value]
        )
      );
      const date = moment().format('YYYY-MM-DD-HHmmss');
      const fileName = `${this.item.name}-Reports-${date}`;

      await exportToExcel(columns, items, fileName);

      this.downloading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverable-tr {
  cursor: pointer;

  &:hover {
    background: #dfdfdf;
  }
}

.drawer-menu--scroll {
  max-height: 600px;
  overflow: auto;
}
</style>
